<template>
    <div>

        <transition name="modal">
            <list-export-modal
                :settings="settings"
                :query="query"
                :pagination="pagination"
                @close="show_export_modal = false"
                v-if="show_export_modal"
            />
        </transition>

        <div class="new-list-group">

            <div class="new-list-group-item new-list-group-header" v-if="showHeader">
                <div class="row g-3">
                    <div :key="'headerCol'+index" v-for="(col, index) in columns" :class="col.class" @click="order(col)">
                        <span :class="{ 'is-sortable' : col.sortable, 'not-sortable' : !col.sortable }" v-if="col.column !== 'check'">
                            {{ col.name }}
                        </span>
                        <span v-if="col.column === 'check'">
                            <input type="checkbox" class="form-check-input" :checked="bulk_selected.length === pagination.limit" @click="checkMassToggle()"/>
                        </span>
                        <li :class="'fa fa-sort-amount-'+pagination.orderDirection"
                            style="margin-left: 4px;"
                            v-if="pagination.orderBy === col.column"
                        />
                    </div>
                </div>
            </div>

            <div class="list-loader-outer">
                <transition name="fade" mode="out-in">
                    <div class="list-loader" v-if="loading">
                        <div class="spinner-border" role="status"></div>
                    </div>
                </transition>
            </div>

            <div class="new-list-group-item" :key="'item'+index" v-for="(item, index) in items">
                <slot name="item-row" :item="item"></slot>
            </div>

            <div class="placeholder-glow w-100" v-if="items.length === 0 && loading === true">
                <span class="placeholder bg-white col-24"></span>
            </div>

            <div class="new-list-group-item inactive" v-if="items.length === 0 && loading === false">
                <div class="row">
                    <div class="col">
                        <span>Inga träffar</span>
                    </div>
                </div>
            </div>

        </div>

        <div class="new-list-utilities">
            <div class="row mt-4 mb-4 mb-md-0">

                <div class="col-18 col-md-6 d-flex" v-if="bulk_actions && bulk_actions.length > 0">
                    <select class="form-select form-select-sm me-2 w-75" v-model="bulk_action">
                        <option :value="null">Välj åtgärd...</option>
                        <option :value="action.event" :key="action.event" v-for="action in bulk_actions">
                            {{ action.label }}
                        </option>
                    </select>
                    <button
                        v-if="bulk_actions && bulk_actions.length > 0"
                        class="btn btn-secondary btn-sm w-25"
                        :disabled="bulk_selected.length === 0  || bulk_action === null"
                        @click="trigger_bulk_action(bulk_action)">
                        Kör
                    </button>
                </div>

                <div class="col-8 col-md-6 d-flex align-items-center" v-if="bulk_actions && bulk_actions.length > 0">
                    <span class="text-info" style="font-size: 0.875rem;">
                        {{ bulk_selected.length }} st av {{ totalItems }} st totalt
                    </span>
                </div>

                <div class="col-12 d-flex align-items-center" v-else>
                    <span class="text-info" style="font-size: 1rem;">
                        Visar {{ items.length }} / {{ totalItems }} träffar
                    </span>
                </div>

                <div class="col-12">

                    <ul class="pagination pagination-sm justify-content-end mb-0">

                        <li class="page-item" :class="{ disabled: pagination.page === 1}" @click="paginate(pagination.page-1)">
                            <a class="page-link" href="#" aria-label="Previous">
                                <span aria-hidden="true">&laquo;</span>
                            </a>
                        </li>
                        <li class="page-item" :class="{ active: pagination.page === n+1  }" :key="'pagination' + n"
                            v-for="n in paginationPages" @click="paginate(n+1)">
                            <a class="page-link" href="#">{{ n + 1 }} <span class="sr-only" v-if="pagination.page === n+1"></span></a>
                        </li>
                        <li class="page-item" :class="{ disabled: pagination.page === numPages }"
                            @click="paginate(pagination.page+1)">
                            <a class="page-link" href="#" aria-label="Next">
                                <span aria-hidden="true">&raquo;</span>
                            </a>
                        </li>

                    </ul>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import _ from 'lodash'
import axios from 'axios'
import Cookies from 'js-cookie'
import ListExportModal from './list-export-modal'

const CancelToken = axios.CancelToken
const source = CancelToken.source()

export default {
    components: { ListExportModal },
    props: {
        settings: {
            required: true
        },
        query: {
            required: true
        },
        useCookies: {
            default: true
        },
        showHeader: {
            default: true
        }
    },

    inject: [
        'get_bulk_selected',
        'trigger_bulk_action',
        'trigger_mass_toggle'
    ],

    data () {
        return {
            url: this.settings.url,
            columns: this.settings.columns,
            bulk_actions: this.settings.bulk_actions,
            bulk_action: null,

            items: [],
            totalItems: [],

            pagination: {
                page: 1,
                limit: 25,
                orderBy: _.find(this.settings.columns, 'default').column,
                orderDirection: _.find(this.settings.columns, 'default').defaultAsc ? 'asc' : 'desc'
            },

            show_export_modal: false,

            loading: false,
            initComplete: false
        }
    },

    mounted () {
        let query = _.cloneDeep(this.settings.query)
        let pagination = null

        if (Cookies.get(this.url)) {
            const parsed = JSON.parse(Cookies.get(this.url))
            query = parsed.query
            pagination = parsed.pagination
        }

        this.$emit('update:query', query)

        /*
        Object.keys(query).forEach((key) => {
            this.$set(this.query, key, query[key])
        })
        */

        if (pagination) {
            Object.keys(pagination).forEach((key) => {
                this.$set(this.pagination, key, pagination[key])
            })
        }

        this.$nextTick(() => {
            this.get().then(() => {
                this.initComplete = true
            })
        })
    },

    computed: {

        bulk_selected () {
            return this.get_bulk_selected()
        },

        numPages () {
            return Math.ceil(this.totalItems / this.pagination.limit)
        },

        paginationPages () {
            const range = _.range(this.numPages)

            if (range.length > 10) {
                const numDrop = this.numPages - 2
                const first = _.dropRight(range, numDrop)
                const last = _.drop(range, numDrop)

                const activePage = parseInt(this.pagination.page)
                const middle = _.range(activePage - 3, activePage + 2)
                const union = _.union(first, middle, last)

                const filter = _.remove(union, (n) => {
                    return n >= 0 && n < this.numPages
                })

                return filter
            }
            return range
        }
    },

    watch: {

        query: {
            handler (val, oldVal) {
                if (!this.initComplete) {
                    return
                }
                this.$set(this.pagination, 'page', 1)
                this.get()
            },
            deep: true
        },

        pagination: {
            handler (val, oldVal) {
                if (!this.initComplete) {
                    return
                }
                this.get()
            },
            deep: true
        }

    },

    methods: {

        get () {
            this.loading = true

            if (this.useCookies) {
                Cookies.set(this.url, JSON.stringify({
                    query: this.query,
                    pagination: this.pagination
                }))
            }

            return new Promise((resolve, reject) => {
                axios.post(this.url, {
                    query: this.query,
                    pagination: this.pagination
                }, {
                    cancelToken: source.token
                })
                    .then((response) => {
                        console.log('get list')
                        console.log(response.data)

                        this.items = response.data.items
                        this.totalItems = response.data.totalItems
                        this.loading = false
                        this.trigger_mass_toggle([])
                        resolve(response.data)
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
        },

        order (column) {
            if (!column.sortable) {
                return
            }

            this.$set(this.pagination, 'page', 1)

            if (this.pagination.orderBy === column.column && this.pagination.orderDirection === 'desc') {
                this.$set(this.pagination, 'orderDirection', 'asc')
                return
            }

            this.$set(this.pagination, 'orderBy', column.column)
            this.$set(this.pagination, 'orderDirection', 'desc')
        },

        paginate (page) {
            if (page === 0 || page > this.numPages) {
                return
            }

            this.$set(this.pagination, 'page', page)
        },

        setPaginationLimit (limit) {
            this.$set(this.pagination, 'page', 1)
            this.$set(this.pagination, 'limit', limit)
        },

        checkMassToggle () {
            const ids = this.items.map(i => i.id)
            this.trigger_mass_toggle(ids)
        },

        openExportModal () {
            this.show_export_modal = true
        }
    }

}

</script>
<style type="text/css">

    /* --- Fade transition --- */
    .fade-enter-active, .fade-leave-active {
      transition: all 500ms;
    }
    .fade-enter, .fade-leave-to {
      opacity: 0;
    }
</style>
